import React from "react";
import { Link } from "react-router-dom";
const Footer = () => {
  const backgroundImage = process.env.PUBLIC_URL + "/bgfooterCatalogue.png";
  const currentYear = new Date().getFullYear();
  return (
    <footer className="bg-[#1E1A18] px-8 py-8 text-white md:h-[80%]">
      <div className="flex flex-col justify-between md:flex-row">
        {/* Left Section: Logo, Title, and Motto */}
        <div className="mb-8 flex-1 lg:mb-0">
          {/* Logo */}
          <img src="/MaduraLogo.svg" alt="Logo" className="mb-4 w-32" />
          {/* Title */}
          <h1 className="text-4xl md:text-5xl font-bold tracking-wide">
            MADURA<br></br> MERCERISERS
          </h1>
          {/* Motto */}
          <p className="mt-4 text-md md:text-xl font-bricolage ">
            Creating Fabric & Garment Excellence
          </p>
          {/* Navigation Links */}
          {/* <div className="mt-8 flex space-x-4 text-md">
            <a href="#" className="hover:underline">
              Most Searched KeyWords
            </a>
            <span>/</span>
            <a href="#" className="hover:underline text-md">
              Additional Links
            </a>
          </div> */}
        </div>

        {/* Right Section: Contact Information */}
        <div className=" flex-1 space-y-6  sm:text-left">
          <div>
            <p className="text-sm uppercase text-gray-400">Location</p>
            <p className="mt-1 text-sm font-bricolage">
              No:5/87A, Angeripalayam Main Rd, Vengamedu,
              <br />
              Tirupur - 641 603,
              <br />
              Tamil Nadu, India
            </p>
          </div>
          <div className="sm:flex sm:space-x-8">
            <div>
              <p className="text-sm uppercase text-gray-400">Contact Us</p>
              <a className="mt-1 text-sm" href="tel:+919445202342">
                +91 9445202342
              </a>
            </div>

            <div className="pt-4 md:pt-0  ">
              <p className="text-sm uppercase text-gray-400">Email</p>
              <a
                className="mt-1 text-sm"
                href="mailto:info@maduramercerisers.com"
              >
                info@maduramercerisers.com
              </a>
            </div>
          </div>
          <div>
            <p className="text-sm  text-gray-400">Monday to Sunday</p>
            <p className="mt-1 text-sm">8AM to 10:30PM</p>
          </div>
        </div>
      </div>

      {/* Bottom Section: Explore website */}
      <div
        className="relative mt-20 p-2  bg-cover bg-center cursor-pointer  rounded-lg"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <a href="/">
          <div className="flex items-center justify-between rounded-lg  p-10">
            <div className="text-left">
              <p className="text-lg   lg:text-xl">Explore </p>

              <p className="text-lg   lg:text-xl">more about us</p>
              {/* <p className="text-2xl font-semibold lg:text-3xl">our Catalogue</p> */}
            </div>
            <div>
              <a href="#" className="text-4xl text-white">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  className="h-6 w-6 transform -rotate-45" // Adjust size and rotation here
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 9l6 6m0 0l-6 6m6-6H3" // This path needs to be adjusted to resemble your uploaded arrow
                  />
                </svg>
              </a>
            </div>
          </div>
        </a>
      </div>

      {/* Footer Bottom */}
      <div className="mt-2 text-center text-gray-400 text-sm">
        © {currentYear} — Copyright
      </div>
    </footer>
  );
};

export default Footer;
